
export const formMixins = require('./form').default;
export const operateMixins = require('./operate').default;
export const multiyearMixins = require('./multiyearcontract').default;
export const multiPromotionMixins = require('./multipromotion').default;
export const itemBaseMixins = require('./ItemmasterBaseinfo').default;





// WEBPACK FOOTER //
// ./src/mixins/index.js